import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import LoadingButton from 'src/components/UI/LoadingButton';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import { deleteBankAccountAction } from 'src/redux/actions/paymentInfoAction';

const DeleteBankAccountDialog = () => {
  const dispatch = useAppDispatch();
  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteBankAccount]) {
        return state.dialog[DIALOGS.deleteBankAccount];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const processing = useSelector(
    (state: Store) => state.formStatus[FORM.delete_bankaccount] === FORM_STATUS.processing,
  );

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteBankAccount }));
  };

  const handleOk = () => {
    if (payload) {
      const { accountId, contactId } = payload;
      dispatch(deleteBankAccountAction(accountId, contactId));
    }
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-bank-account"
      open={opened}>
      <DialogTitle id="deleting-bank-account">{t(lang, 'menus.deleting_bankaccount')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.deleting_bankaccount_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary" disabled={processing}>
          {t(lang, 'misc.no')}
        </Button>
        <LoadingButton onClick={handleOk} color="primary" loading={processing}>
          {t(lang, 'misc.yes')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteBankAccountDialog;
